import React from 'react';
import Analytics from './components/Analytics';
import Cards from './components/Cards';
import Footer from './components/Footer';
import Hero from './components/Hero';
import Navbar from './components/Navbar';
import Newsletter from './components/Newsletter';
import { Route, HashRouter as Router, Routes } from "react-router-dom";
import Layout from './components/Layout';
import Home from './rasas/pages/home/Home';
import Login from "./rasas/pages/login/Login";
import List from "./rasas/pages/list/List";
import Single from "./rasas/pages/single/Single";
import New from "./rasas/pages/new/New";
import { productInputs, userInputs } from "./rasas/formSource";
import "./rasas/style/dark.scss";
import { useContext } from "react";
import { DarkModeContext } from "./rasas/context/darkModeContext";
import Datasets from './rasas/pages/datasets/datasets';
import { useState } from "react";
import SignUp from './components/SignUp';
import ProtectedRoute from './components/ProtectedRoute.jsx';
import { AuthContextProvider } from './context/AuthContext';
import Products from './components/Products/products';
import Pricing from './components/Pricing/Pricing';
import Company from './components/Company/Company';


function App() {
  const { darkMode } = useContext(DarkModeContext);


  return (
    <div className={darkMode ? "app dark" : "app"}>
      {/**
       <AuthContextProvider>
        <Routes>
          <Route path='/' element={<Signin />} />
          <Route path='/signup' element={<Signup />} />
          <Route
            path='/account'
            element={
              <ProtectedRoute>
                <Account />
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthContextProvider>
       */}
       <AuthContextProvider>
      <Router>
          <Routes path="/">
            <Route index element={<Layout />} />
            <Route path="login" element={<Login />} />
            <Route path="signup" element={<SignUp />} />
            <Route path="products" element={<Products />} />
            <Route path="pricing" element={<Pricing/>} />
            <Route path="company" element={<Company/>} />
            
            <Route path="rasas" element={
            <ProtectedRoute>
            <Home />
            </ProtectedRoute>
            } />
            
            <Route path="users">
              <Route index element={<List />} />
              <Route path=":userId" element={<Single />} />
              <Route
                path="new"
                element={<New inputs={userInputs} title="Add New User" />} />
            </Route>
            <Route path="datasets">
              <Route index element={<Datasets />} />
              <Route path=":datasetId" element={<Datasets />} />
              <Route
                path="new"
                element={<New inputs={productInputs} title="Add New Product" />}
              />
            </Route>
          </Routes>
        
      </Router>
      </AuthContextProvider>
    </div>
  );
}

export default App;
